// Safe color sanitizer — zero-black protection
// Parse [R,G,B] array atau CSS string, clamp agar tidak pernah pitch-black (min 30 per channel)

export function toRGB(input) {
  if (Array.isArray(input)) {
    return [clamp(input[0]), clamp(input[1]), clamp(input[2])];
  }
  if (typeof input === "string") {
    const s = input.trim();
    if (/^#([0-9a-fA-F]{6})$/.test(s)) {
      return [parseInt(s.slice(1, 3), 16), parseInt(s.slice(3, 5), 16), parseInt(s.slice(5, 7), 16)].map(clamp);
    }
    const m = s.match(/(\d{1,3})[,\s]+(\d{1,3})[,\s]+(\d{1,3})/);
    if (m) return [clamp(+m[1]), clamp(+m[2]), clamp(+m[3])];
  }
  return [200, 200, 200]; // fallback terang
}

function clamp(v) {
  const n = Number(v);
  if (Number.isNaN(n)) return 128;
  return Math.max(30, Math.min(255, Math.round(n))); // min 30 → tidak pernah hitam pekat
}

export function cssCol(input, alpha = 1) {
  const [r, g, b] = toRGB(input);
  return `rgba(${r},${g},${b},${alpha})`;
}

// Gelapkan/terangkan warna dengan aman (untuk sisi bayangan bangunan)
export function shade(input, factor) {
  const [r, g, b] = toRGB(input);
  return cssCol([r * factor, g * factor, b * factor]);
}
